import React, { useState, useEffect } from 'react';

const InstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    setIsStandalone(standalone);
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);
    const dismissed = localStorage.getItem('installPromptDismissed');
    const dismissedTime = dismissed ? parseInt(dismissed) : 0;
    const daysSinceDismissed = (Date.now() - dismissedTime) / (1000 * 60 * 60 * 24);
    if (standalone || (dismissed && daysSinceDismissed < 7)) return;

    const handleBeforeInstall = (e) => { e.preventDefault(); setDeferredPrompt(e); setShowPrompt(true); };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    if (iOS && !standalone) setTimeout(() => setShowPrompt(true), 3000);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') setShowPrompt(false);
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => { localStorage.setItem('installPromptDismissed', Date.now().toString()); setShowPrompt(false); };

  if (!showPrompt || isStandalone) return null;

  return (
    <div style={{position:'fixed',bottom:0,left:0,right:0,zIndex:9999,padding:'12px',background:'linear-gradient(transparent, rgba(0,0,0,0.3))'}}>
      <div style={{background:'#fff',borderRadius:'16px',padding:'16px',boxShadow:'0 4px 20px rgba(0,0,0,0.15)',maxWidth:'400px',margin:'0 auto'}}>
        <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'12px'}}>
          <div style={{fontSize:'32px',background:'#0071e3',borderRadius:'12px',width:'48px',height:'48px',display:'flex',alignItems:'center',justifyContent:'center'}}>⚓</div>
          <div style={{flex:1}}>
            <strong>Add 1crew3 to Home Screen</strong>
            {isIOS ? (<p style={{margin:'4px 0 0',fontSize:'13px',color:'#666'}}>Tap <span style={{border:'1px solid #007aff',borderRadius:'4px',padding:'0 4px',color:'#007aff',fontSize:'12px'}}>⎙</span> then "Add to Home Screen"</p>) : (<p style={{margin:'4px 0 0',fontSize:'13px',color:'#666'}}>Get quick access and push notifications</p>)}
          </div>
        </div>
        <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
          {!isIOS && deferredPrompt && (<button onClick={handleInstall} style={{background:'#0071e3',color:'#fff',border:'none',borderRadius:'8px',padding:'10px 20px',fontSize:'14px',fontWeight:'600',cursor:'pointer'}}>Install</button>)}
          <button onClick={handleDismiss} style={{background:'#f0f0f0',color:'#333',border:'none',borderRadius:'8px',padding:'10px 20px',fontSize:'14px',fontWeight:'500',cursor:'pointer'}}>{isIOS ? 'Got it' : 'Not now'}</button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
